import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import { Layout } from 'antd'
import { Col } from 'antd'
import Overviewdetails from './components/Overviewdetails'
import Projectmember from './components/Projectmember'
import TaskCircleprogress from './components/TaskCircleprogress'
import Kpifinance from './components/Kpifinance'
import Supportneed from './components/Supportneed'
import '../../styleLess/signature/overviewAll.scss'
import { getProjectById } from 'api/Project/project'
import { getCookie } from 'helper/cookie'
import { RightOutlined } from '@ant-design/icons'
import { useParams } from 'react-router-dom'
import imgDefault from 'icons/Ellipse1.svg'
import { useHistory } from 'react-router-dom'
import { getauthorityUser } from 'api/Account/permission'
import { Helmet } from 'react-helmet'
import { DOCUMENT_SUMMARY_REPORT } from 'api/Overview/overview'
import 'styleLess/signature/shimmerloading.scss'
import TaskProgress from './components/taskprogress'
import Overdue from './components/overdue'
import { CounterContext } from 'redux/Golbalvalues'
const { Content } = Layout
const Container = styled.div`
  // width: 100%;
  // background: #ffffff;
  // padding: 24px;
`
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
  line-height: 2;
`
const initalState = {
  data: [],
  isLoading: false,
}

const OverviewMain = (props) => {
  const [dataProject, setDataProject] = useState(initalState.data)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  const [reportDataprojectfile, setReportDataprojectfile] = useState(initalState.data)
  const [canViewKpi, setCanViewKpi] = useState(false)
  const [logo, setLogo] = useState(imgDefault)
  const history = useHistory()
  const { id } = useParams()
  const [valueRole, setValueRole] = useState(initalState.data)


  const { mainRoleUser, adminPermission, setPathActive } = useContext(CounterContext)
  const getDataProjectById = async () => {
    await getProjectById({
      id: id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setDataProject([])
          return true
        }
        if (status === 200) {
          await setDataProject(data)
          if (data.logo) {
            await setLogo(data.logo[0].urlfile)
          }
          setIsLoading(true)
        } else {
          setIsLoading(true)
          return true
        }
      })
      .catch((error) => {
        console.error(error)
        setIsLoading(true)
      })
  }

  const getReportFileProject = async () => {
    await DOCUMENT_SUMMARY_REPORT({
      id: id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setReportDataprojectfile([])
          return true
        }
        if (status === 200) {
          await setReportDataprojectfile(data)
        } else {
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const getroleAuthority = async () => {
    await getauthorityUser({
      id: id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          return true
        }
        if (status === 200) {
          setValueRole(data)
          var str = data.permission
          if (str.includes('3')) {
            setCanViewKpi(true)
          } else {
            setCanViewKpi(false)
          }
          if (!str.includes('1') && mainRoleUser != 1 && mainRoleUser != 9) {
            // history.push('/no-permission')
          }
        } else {
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      setIsLoading(false)
      window.scrollTo(0, 0)
      getDataProjectById()
      getReportFileProject()
      getroleAuthority()
    }
  }, [token])
  const goProjectList = () => {
    history.push('/project-list')
  }

  return (
    <Container className='main-container'>
      <Helmet>
        <title>AXONS PROJECT | Overview</title>
      </Helmet>
      <div className='BreadCrumb '>
        <h4 className='level1' onClick={() => goProjectList()}>
          Project
        </h4>
        <RightOutlined className='icon-style' style={{ marginTop: -6 }} />
        <h4
          className='level2 cutter-text-line-1 '
          style={{ minHeight: 28, maxWidth: '60%' }}
        >
          {dataProject.name}
        </h4>
      </div>
      <h1
        className='cutter-text-line-1 responset'
        style={{
          minHeight: 43,
          maxWidth: '64%',
          fontFamily: 'IBMPlexSansThaiBold',
          lineHeight: 2,
        }}
      >
        {dataProject.name}
      </h1>
      <Layout className='layout-a'>
        <Col className='box1'>
          <Overviewdetails
            dataProject={dataProject}
            dataReport={reportDataprojectfile}
            dataLogo={logo}
            isLoading={isLoading}
          />
        </Col>
        <Col className='box2'>
          <Projectmember project_id={id}></Projectmember>
        </Col>
      </Layout>
      <Layout className='layout-b'>
        <Content className='box1'>
          <Kpifinance
            project_id={id}
            canViewKpi={canViewKpi}
            mainRoleUser={mainRoleUser}
          />
        </Content>
        <Content className='box2'>
          <TaskCircleprogress project_id={id} />
        </Content>
      </Layout>
      <Layout className='layout-c'>
        <Content className='box1'>
          <Supportneed
            idProject={id}
            valueRole={valueRole}
            mainRoleUser={mainRoleUser}
            dataProject={dataProject} />
        </Content>
        <Content className='box2'>
          <TaskProgress project_id={id} project_status_id={dataProject?.status_id} />
        </Content>
      </Layout>
      <Layout className='layout-d'>
        <Content className='box1'>
          <Overdue project_id={id} project_status_id={dataProject?.status_id} />
        </Content>
      </Layout>
    </Container>
  )
}

export default OverviewMain
